import React from 'react'
import { useEventDailyInsight } from '../hooks/useEventDailyInsight'

export const EventDailyInsightWidget: React.FC = () => {
    const { data, loading, error } = useEventDailyInsight()

    if (loading) {
        return (
            <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <span className="text-gray-400 fw-semibold fs-7 mt-3">Caricamento insight...</span>
                </div>
            </div>
        )
    }

    // Fallback for null data or error
    if (error || !data) {
        return (
            <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                <div className="d-flex flex-column justify-content-center align-items-center py-2">
                    <i className="ki-outline ki-chart-pie-simple fs-2x text-primary mb-3"></i>
                    <div className="d-flex flex-column align-items-center">
                        <span className="text-gray-800 fw-bold fs-6 mb-1">Analisi competitor</span>
                        <span className="text-gray-400 fw-semibold fs-7">Insight non ancora disponibile</span>
                    </div>
                </div>
            </div>
        )
    }

    // Determine colors
    const attentionColors = {
        high: 'danger',
        medium: 'warning',
        low: 'success'
    }

    const color = attentionColors[data.signals.attentionLevel] || 'success';
    const isDeltaPositive = data.signals.activityDelta >= 0;

    return (
        <div className="card card-custom bg-white shadow-sm mb-5 border-0">
            <div className="card-body p-6">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-start mb-4">
                    <div className="d-flex align-items-center">
                        <i className="ki-outline ki-chart-pie-simple fs-2x text-primary me-3"></i>
                        <div>
                            <div className="text-gray-800 fw-bold fs-6">Analisi Competitor</div>
                            <div className="text-gray-400 fs-8 fw-semibold">Daily Insight</div>
                        </div>
                    </div>
                    <span className={`badge badge-light-${color} fw-bold fs-8 d-flex align-items-center`}>
                        <i className={`ki-outline ki-notification-status fs-8 text-${color} me-1`}></i>
                        Attenzione
                    </span>
                </div>

                {/* Metrics Grid */}
                <div className="d-flex align-items-end justify-content-between mb-4">
                    {/* Score */}
                    <div>
                        <div className="text-gray-500 fw-semibold fs-8 mb-1">Activity Score</div>
                        <div className="d-flex align-items-center">
                            <span className="fs-2x fw-bold text-gray-800 lh-1 me-2">{data.signals.activityScore}</span>
                            <span className="badge badge-light fs-8 fw-bold text-gray-400">Baseline iniziale</span>
                        </div>
                    </div>

                    {/* Secondary stats */}
                    <div className="d-flex flex-column text-end">
                        <div className="text-gray-800 fw-bold fs-7">{data.metrics.totalEvents} <span className="text-gray-400 fw-semibold fs-8">eventi</span></div>
                        <div className="text-gray-800 fw-bold fs-7">{data.metrics.activeCompetitors} <span className="text-gray-400 fw-semibold fs-8">comp.</span></div>
                    </div>
                </div>

                {/* AI Summary */}
                <div className={`bg-light-${color} rounded p-4 bg-opacity-10`}>
                    <div className="d-flex align-items-center mb-3">
                        <i className={`ki-outline ki-artificial-intelligence fs-4 text-${color} me-2`}></i>
                        <span className={`text-${color} fw-bold fs-8`}>AI Synthesis</span>
                    </div>

                    {data.aiSummary.short && (
                        <p className={`text-gray-700 fs-8 fw-semibold lh-base ${data.aiSummary.bullets && data.aiSummary.bullets.length > 0 ? 'mb-3' : 'mb-0'}`}>
                            {data.aiSummary.short}
                        </p>
                    )}

                    {data.aiSummary.bullets && data.aiSummary.bullets.length > 0 && (
                        <ul className="mb-0 ps-0 list-unstyled">
                            {data.aiSummary.bullets.slice(0, 3).map((bullet, index) => (
                                <li key={index} className="d-flex align-items-start mb-2 last-mb-0">
                                    <span className={`bullet bullet-dot bg-${color} h-6px w-6px me-2 mt-2 flex-shrink-0`}></span>
                                    <span className="text-gray-700 fs-8 fw-semibold lh-base">{bullet}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    )
}

